module.exports = __webpack_public_path__ + "static/media/cw-logo.d1a18442.png";